import NavBar  from "./nav-bar";
import Hero from "./hero";
export default function Header(){

return (
    <header>
    <NavBar/>
    <Hero/>
   </header>
);
}

